import styled from 'styled-components';
import {
  Flex,
} from 'web-styled';
import {
  Link,
} from 'react-router';

export const Item = styled(Flex).attrs({
  flex: '0 0 40px',
  justify: 'space-between',
})`
  margin: 0;
  width: 100%;
  padding: 10px 15px;

  .actions {
    opacity: 0;
  }

  &:first-of-type {
    margin-top: 10px;
  }

  &:hover {
    background: #fbfbfb;

    .actions {
      opacity: 1;
    }
  }

  &:hover div:last-of-type {
    visibility: visible;
  }

`;

export const Name = styled(Link)`
 font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${props => (props.inactive ? '#858585' : props.theme.colors.link)};
  line-height: 30px;

  & > i {
    margin: 0 5px;
    width: 23px;
    height: 13px;
  }
`;

export const Empty = styled(Flex).attrs({
  column: true,
  spacing: 10,
  align: 'center',
  justify: 'center',
})`
  width: 100%;
  height: 100%;
  color: #ccc;
  text-align: center;
  font-size: 12px;
`;

export const EmptyIcon = styled.img`
  width: 46px;
  height: 54px;
  filter: invert(78%) sepia(5%) saturate(27%) hue-rotate(251deg) brightness(98%) contrast(107%);
`;
